// Role hierarchy mirror of the backend (auth.py ROLE_LEVEL).
const LEVEL = { viewer: 0, field_agent: 1, staff: 2, manager: 3, owner: 4, admin: 4 };

export const roleLevel = (user) => LEVEL[user?.role] ?? 0;
export const isOwner = (user) => roleLevel(user) >= 4;
export const isManager = (user) => roleLevel(user) >= 3;
export const canWrite = (user) => roleLevel(user) >= 2;
